/*
 * File: CustomCheckbox.tsx
 * Project: a-a
 * File Created: Friday, 11th October 2024 6:24:24 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 30th September 2025 9:01:58 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import zeplinColor from '../../../theme/Color';
import { Box } from '@mui/material';

type CheckboxProps = {
  label: string;
  checked: boolean; // Add a `checked` prop to control the state
  onChange: (checked: boolean) => void; // Add an `onChange` handler
};

const CustomCheckbox = ({ label, checked, onChange }: CheckboxProps) => {
  return (
    // <FormGroup>
    <Box sx={{ width: '100%' }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked} // Controlled state
            onChange={(event) => onChange(event.target.checked)} // Pass the updated state to the parent
            sx={{
              color: zeplinColor.BasicBlack,
              '&.Mui-checked': { color: zeplinColor.BasicBlack },
            }}
          />
        }
        label={label}
        labelPlacement='end'
        componentsProps={{
          typography: { style: { pointerEvents: 'none' } }, // Make label not clickable
        }}
        style={{ color: zeplinColor.Neutral9 }}
      />
    </Box>
    // </FormGroup>
  );
};

export default CustomCheckbox;
